import TagAction from "./TagAction";
import BaseReducer from "../../utilities/BaseReducer";

// reducer function
export default class TagFilterReducer extends BaseReducer {
  initialState = {
    tagfilter: [],
  };

  [TagAction.REQUEST_TAG_FILTER_FINISHED](state, action) {
    return {
      ...state,
      tagfilter: action.payload,
    };
  }
}
